import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { LoaderHandlerService } from 'src/app/services/loader-handler.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { MonotainerTaggingDetailsComponent } from '../../entities-profile/monotainer-tagging-details/monotainer-tagging-details.component';
import {
  ActionMode,
  AggregateEntityResponse,
  AggregatePayload,
  ButtonColor,
  ButtonIconColor,
  ButtonModel,
  ButtonOption,
  ButtonSize,
  ButtonType,
  DataBroadcast,
  DataBroadcastModel,
  EntityCardView,
  EntityCardViewType,
  EntityIconModel,
  EntityModel,
  EntityOnboardStateModel,
  EntityTagStatus,
  EntityTagStatusType,
  EntityTileModel,
  EntityTileOutputModel,
  EntityValue
} from 'src/app/model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Messages } from 'src/app/constants/messages';
import { EntitiesServiceService } from 'src/app/shared/services';
import { AppliedFilter, FilterFields } from 'src/app/model/shared/components/filter-panel';
import { DatePipe } from '@angular/common';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

@Component({
  selector: 'app-entities-listing',
  templateUrl: './entities-listing.component.html',
  styleUrls: ['./entities-listing.component.css']
})
export class EntitiesListingComponent implements OnInit, OnDestroy {

  @Input()
  set list(value: EntityTileModel) {
    this._list = value;
    this._setEntityIconList(value);
    // Set entity onboarding button based on RBAC
    this._setEntityOnboardFormButton();
    if (JSON.stringify(value) !== JSON.stringify(this._previousList)) {
      this._previousList = value;
      const appliedEntityFilter = this.service.getFilters('entity');
      const appliedEntitySearchKey = this.service.getSearchKey('entity');
      const appliedDtcAlertFilter = !!(this.service.getAlertDtcFilters('isActiveAlerts') || this.service.getAlertDtcFilters('isActiveDTCCases'));
      if (this.appliedFilter || this._searchKey || this._appliedFilterCategory || this.entitiyFilters?.isActiveAlerts || this.entitiyFilters?.isActiveDTCCases) {
        if (this._appliedFilterCategory) {
          const categoryValue = this._appliedFilterCategory['category']?.[0];
          if (this.appliedFilter?.['category']) {
            if (!this.appliedFilter['category'].includes(categoryValue)) {
              this.appliedFilter['category'].push(categoryValue);
            }
          } else {
            this.appliedFilter = { ...this.appliedFilter, ...this._appliedFilterCategory };
          }
        }
        this._calculateAggregate();
      } else if ((appliedEntityFilter && Object.keys(appliedEntityFilter)?.length) || (appliedEntitySearchKey) || appliedDtcAlertFilter) {
        this.isWidgetShow = true;
        this._calculateAggregate();
      }
      if(this.service.getEntitiesFilter()?.length){
        this.isWidgetShow = true;
        this._calculateAggregate();
      }
    }
  }

  get list() {
    return this._list;
  }

  @Input()
  set filterApplied(value: boolean) {
    this._filterApplied = value;
  }

  get filterApplied() {
    return this._filterApplied;
  }

  @Input()
  set appliedFilterCategory(value: boolean) {
    this._appliedFilterCategory = value;
  }

  get appliedFilterCategory() {
    return this._appliedFilterCategory;
  }

  @Input() _appliedFilterCategory: any;
  @Input() alertsCount: any;
  public _filterApplied: boolean;
  @Output() searchData = new EventEmitter<any>();
  @Output() apiRefresh = new EventEmitter<any>();
  @Output() widgetFilter = new EventEmitter<any>();
  @Output() clearFilters = new EventEmitter<any>();

  // Flag
  loadStatus: boolean = true;
  isActiveFilter: boolean = true;
  toggle: boolean = true;
  isShow: boolean = false;
  isTaggable: boolean = false;
  isUntag: boolean = false;
  isOpenFilter: boolean = false;
  isWidgetShow: boolean = false;
  selectedCardId: string | null = null;
  setLabel: string;

  // Miscellaneous
  uniqueIdList: string[] = [];
  siteId: string;
  appliedFilter: AppliedFilter;
  entitiyFilters: { filterFields: AppliedFilter, operationalStatusFilter: string[], alertsFilter: string[], isActiveAlerts: any, isActiveDTCCases: any } =
    { filterFields: null, operationalStatusFilter: [], alertsFilter: [], isActiveAlerts: false, isActiveDTCCases : false };
  private _previousList: EntityTileModel | null = null;
  public filterCount: number = 0;

  // Configuration
  tenantCategory: string;
  private _tenantGenericConfig: any;
  private _iconsList: EntityIconModel[] = [];

  //Widgets list
  vehicleWidgets = [{ id: "totalVehicle", title: "Total Vehicles", icon: "../../../../assets/images/totalVehicles.svg", value: null, trimmedValue: null },
  { id: "totalDistance", title: "Total Kms Covered", icon: "../../../../assets/images/kmsCoveredIcon.svg", value: null, trimmedValue: null },
  { id: "totalEnginehours", title: "Operating Hrs", icon: "../../../../assets/images/operatingHrsIcon.svg", value: null, trimmedValue: null },
  { id: "totalAlerts", title: "Alerts", icon: "../../../../assets/images/Alert-Icon-Validops.svg", value: 0, trimmedValue: null }]

  public filterFields: FilterFields;
  isAlertIncluded : {include: boolean, fieldName: string};
  isDtcIncluded : {include: boolean, fieldName: string};

  // Form control
  tag = new FormControl();
  unTag = new FormControl();

  // Button
  entityOnboardButton: ButtonModel;

  // Icon
  entityIconGroup: EntityIconModel;

  // Card view
  entityList: EntityModel[];
  entityCardView: EntityCardViewType;
  readonly ENTITY_CARD_VIEW = EntityCardView;
  readonly ENTITY_TAG_STATUS = EntityTagStatus;

  public _searchKey: any;
  private _list: EntityTileModel = {} as EntityTileModel;

  // Subscription
  private _subscription: Subscription;
  private _loaderSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _entitiesAggrSubscription: Subscription;

  private listSubject = new Subject<EntityTileModel>();
  private listSubscription: Subscription;

  //Date-Time Range
  public datepickerForm: FormGroup;
  private _selectedDates = {
    from: null,
    to: null,
  };
  aggrData: any;

  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }

  constructor(
    private _router: Router,
    private _dialog: MatDialog,
    public service: ServicecallService,
    private _dataSer: DataService,
    private _loaderHandler: LoaderHandlerService,
    private _entitiesService: EntitiesServiceService,
    private _route: ActivatedRoute,
    private _datePipe: DatePipe,
    private _fb: FormBuilder,
  ) {
    // Set configuration;
    this._setConfiguration();
    // Filter
    const url = this._router.url.split('/');
    if (url?.[2] === 'inactive') {
      this.isActiveFilter = false;
    }
    // Broadcast
    this._subscription = this._dataSer.events
      .subscribe({
        next: (broadcast: DataBroadcastModel) => {
          if (broadcast.name === DataBroadcast?.SITE_CHANGED || broadcast.name === DataBroadcast.API_REFRESH) {
            this._setConfiguration();
            // Set entity onboarding button based on RBAC
            this._setEntityOnboardFormButton();
          }
        }
      });
    // Loader
    this._loaderSubscription = this._loaderHandler.handler$
      .subscribe({
        next: (value) => {
          this.loadStatus = value;
        }
      });
  }

  ngOnInit(): void {
    // Set card view
    this._setEntityCardView();
    this._initializeForm();
    this.filterFields = this.service.getConfiguration("entityFilter")?.filterEntityFields?.filterFields ?? {};
    this.isAlertIncluded = this.service.getConfiguration("entityFilter")?.filterEntityFields?.includeAlerts ?? false;
    this.isDtcIncluded = this.service.getConfiguration("entityFilter")?.filterEntityFields?.includeDtc ?? false;
    const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const { startDate, endDate } = this._tenantGenericConfig?.defaultTimeRange
      ? this.service.calculateDateRange(this._tenantGenericConfig.defaultTimeRange)
      : { startDate: defaultStartDate, endDate: new Date() };

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    this.saveTime();
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._loaderSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();
    this._entitiesAggrSubscription?.unsubscribe();
    this.listSubscription?.unsubscribe();
  }

  /**
   * Determines whether tag option changed on
   * @param tagStatus
   * @param event
   */
  onTagOptionChanged(tagStatus: EntityTagStatusType, event: MatCheckboxChange) {
    this.isTaggable = true;
    const entityListTemp: EntityModel[] = [...this.list?.data];
    if (tagStatus === EntityTagStatus.TAG) {
      if (event?.checked) {
        this.isUntag = false;
        this.list.data = this.list?.data?.filter((item: EntityModel) => item?.assetDetails?.state === 'init');
        if (!this.list.data?.length) {
          this.isShow = true;
        }
      }
    } else if (tagStatus === EntityTagStatus.UNTAG) {
      if (event?.checked) {
        this.isUntag = true;
        this.list.data = this.list?.data?.filter((item: any) => item.assetDetails?.state === 'outside' || item.assetDetails?.state === 'missing' || item.assetDetails?.state === 'sortarea');
        if (!this.list.data?.length) {
          this.isShow = true;
        }
      }
    }
    if (!event?.checked) {
      this.isTaggable = false;
      this.uniqueIdList = [];
      this.list.data = entityListTemp;
    }
  }

  /**
   * Determines whether tile header tag changed on
   * @param event
   */
  onTileHeaderTagChanged(event: EntityTileOutputModel) {
    if (event?.event) {
      this.uniqueIdList.push(event?.value);
    } else {
      const index = this.uniqueIdList?.indexOf(event?.value);
      if (index >= 0) {
        this.uniqueIdList.splice(index, 1);
      }
    }
  }

  /**
   * Determines whether tag or untag click on
   * @param isUntag
   */
  onTagOrUntagClick(isUntag: boolean) {
    let dialogRef = this._dialog.open(
      MonotainerTaggingDetailsComponent,
      {
        width: '30%',
        disableClose: true,
        data: {
          msg: isUntag ? 'multiUntag' : 'multitag',
          taggedDetails: {
            id: this.uniqueIdList,
            site: this.service.getSiteId()
          }
        }
      }
    );
    this._afterClosedSubscription = dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.apiRefresh.emit();
          this.uniqueIdList = [];
          this.isTaggable = false;
          this.tag.setValue(false);
          this.unTag.setValue(false);
        }
      });
  }

  /**
   * Determines whether mat card click on
   * @param id
   */
  onMatCardClick(id: string) {
    if (this.selectedCardId === null) {
      // Navigate to entity detail page
      this._router.navigate([this.list?.pageType + '/profile/' + id]);
    }
  }

  /**
   * Determines whether search item on
   * @param keyword
   */
  onSearchItem(keyword: string) {
    if (keyword) {
      this.isWidgetShow = true;
    } else {
      if (!this.filterCount) {
        this.isWidgetShow = false;
      }
    }
    this._searchKey = keyword;
    this.searchData.emit(this._searchKey);
    // this._calculateAggregate();
  }

  /**
   * Determines whether change view on
   * @param view
   */
  onChangeView(view: boolean) {
    this.toggle = view;
  }

  /**
   * Tracks by entity item
   * @param index
   * @param item
   * @returns
   */
  trackByEntityItem(index: number, item: EntityModel) {
    return item?.iconDetails;
  }

  /**
   * Determines whether entity onboard button click on
   * @param buttonContent
   */
  onEntityOnboardButtonClick(event: MouseEvent, buttonContent: ButtonModel) {
    // Stop event propagation
    event?.stopPropagation();
    // Navigate to entity onboard form
    if (buttonContent?.action === ActionMode.ADD) {
      this._router.navigate(
        [this.list?.pageType + '/onboard'],
        {
          state: {
            formStatus: ActionMode.ADD
          } as EntityOnboardStateModel
        }
      );
    }
  }

  /**
   * Determines whether entity overlay action on
   * @param event
   * @param entityData
   * @param action
   */
  onEntityOverlayAction(event: Event, entityData: EntityModel, action: string) {
    event.stopPropagation(); // Prevent card's click event
    if (action === 'edit') {
      this.selectedCardId = null;
      this._router.navigate(
        [this.list?.pageType + '/onboard'],
        {
          state: {
            entityId: entityData?._id,
            formStatus: ActionMode.UPDATE
          } as EntityOnboardStateModel
        }
      );
    } else if (action === 'delete') {
      this.selectedCardId = null;
    }
  }

  /**
   * Sets entity card view
   */
  private _setEntityCardView() {
    this.entityCardView = this._tenantGenericConfig?.entityCardView
      ? EntityCardView?.[this._tenantGenericConfig?.entityCardView]
      : EntityCardView?.GENERIC;
  }

  /**
   * Sets configuration
   */
  private _setConfiguration() {
    this.siteId = this.service?.getSiteId();
    this.tenantCategory = this.service.getConfiguration('tenantCategory') ? this.service.getConfiguration('tenantCategory')?.tenantCategory?.category : null;
    this._tenantGenericConfig = this.service.getConfiguration('tenantGenericConfig') ? this.service.getConfiguration('tenantGenericConfig') : null;
    this._iconsList = this.service?.getConfiguration('entityIconList') ? this.service?.getConfiguration('entityIconList')?.entityIconList : [];
  }

  /**
   * Sets entity icon list
   * @param list
   */
  private _setEntityIconList(list: EntityTileModel) {
    this.entityIconGroup = [...this._iconsList]
      ?.find((element) => element?.entityType?.toString() === list?.entityType?.toString());
  }

  /**
   * Handles filter
   */
  public handleFilter(collapse?: boolean | string) {
    this.isOpenFilter = (collapse && collapse !== "applyFilter") ? collapse as boolean : false;
    if (collapse === "applyFilter") {
      this.isWidgetShow = true;
    }
  }

  /**
   * Handles back
   */
  public handleBack() {
    this.service.setEntitiesFilter([]);
    //Call api without category filter
    this.service.setFilters({}, 'entity');
    this.service.setSearchKey(null, 'entity');
    this.service.setAlertDtcFilters(false, 'isActiveAlerts');
    this.service.setAlertDtcFilters(false, 'isActiveDTCCases');
    this.isWidgetShow = false;
    this.isOpenFilter = false;
    this.appliedFilter = null;
    this._appliedFilterCategory = null;
    this._searchKey = null;
    this.entitiyFilters = { filterFields: null, operationalStatusFilter: [], alertsFilter: [], isActiveAlerts : false, isActiveDTCCases: false };
    this._filterApplied = false;
    this.filterFields = this.service.getConfiguration("entityFilter")?.filterEntityFields?.filterFields ?? {};
    this.isAlertIncluded = this.service.getConfiguration("entityFilter")?.filterEntityFields?.includeAlerts ?? false;
    this.isDtcIncluded = this.service.getConfiguration("entityFilter")?.filterEntityFields?.includeDtc ?? false;
    this.filterCount = 0;
    this.clearFilters.emit();
    // this.searchData.emit(this._searchKey);
    // this.widgetFilter.emit(this.appliedFilter);
  }

  public clearAllFilters() {
    this.handleBack();
  }

  /**
   * Calculates aggregate
   */
  private _calculateAggregate() {
    let configStartDate = null;
    let configEndDate = null;

    if (this._tenantGenericConfig?.defaultTimeRange) {
      const configHour = this._tenantGenericConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.service.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    let reqPayload: AggregatePayload = {
      entityIds: this.service.getEntitiesFilter()?.length ? this.service.getEntitiesFilter() : [],
      groupBy: "entity",
      from: this._datePipe.transform(configStartDate ?? startDate, 'yyyy-MM-ddTHH:mm:ssZ'),
      to: this._datePipe.transform(configEndDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZ'),
      ...(this._tenantGenericConfig?.excludeFromFieldInFilters && {excludeFromFieldInFilters : this._tenantGenericConfig?.excludeFromFieldInFilters })
    };
    const appliedEntityFilter = this.service.getFilters('entity');

    this.filterCount = Object.values(this.appliedFilter?.['filterFields'] ?? this.appliedFilter ?? appliedEntityFilter ?? {}).flat()?.length || 0;
    this.entitiyFilters.isActiveAlerts = this.entitiyFilters.isActiveAlerts || this.service.getAlertDtcFilters('isActiveAlerts');
    this.entitiyFilters.isActiveDTCCases = this.entitiyFilters.isActiveDTCCases || this.service.getAlertDtcFilters('isActiveDTCCases');
    this.appliedFilter = (this.appliedFilter && Object.keys(this.appliedFilter).length ? this.appliedFilter : appliedEntityFilter && Object.keys(appliedEntityFilter).length ? appliedEntityFilter : {} );

    if ((this.appliedFilter && Object.keys(this.appliedFilter)?.length) || (appliedEntityFilter && Object.keys(appliedEntityFilter)?.length)) {
      const activeFilter = this.appliedFilter ?? appliedEntityFilter;
      const filterFields = activeFilter?.['filterFields'] ?? activeFilter;
      reqPayload = { ...reqPayload, ...filterFields };
    }
    const isActiveAlerts = this.entitiyFilters?.isActiveAlerts || this.service.getAlertDtcFilters('isActiveAlerts');
    const isActiveDTCCases = this.entitiyFilters?.isActiveDTCCases || this.service.getAlertDtcFilters('isActiveDTCCases');
    reqPayload = { ...reqPayload, ...(isActiveAlerts && {isActiveAlerts : true}), ...(isActiveDTCCases && {isActiveDTCCases : true}) };
    // if (this._appliedFilterCategory && Object.keys(this._appliedFilterCategory)?.length) {
    //   reqPayload = { ...reqPayload, ...this._appliedFilterCategory };
    // }
    if (this.service.getSiteId()) {
      reqPayload.siteId = this.service.getSiteId();
    }

    //SearchKey
    const searchKey = this._searchKey ?? this.service.getSearchKey('entity');
    if (searchKey) {
      this._searchKey = searchKey;
      reqPayload.searchKey = searchKey;
    }

    this._entitiesAggrSubscription = this._entitiesService.getEntityAggrSummary(reqPayload, true, 'vehicleList').subscribe(
      {
        next: (result: AggregateEntityResponse) => {
          if (result) {
            this.vehicleWidgets = this.vehicleWidgets?.map(item => {
              switch (item.id) {
                case "totalVehicle":
                  return { ...item, value: this._list?.data?.length ? result?.entityCount : 0, trimmedValue: result?.entityCount };
                case "totalDistance":
                  return { ...item, value: this._list?.data?.length ? result?.totalDistance : 0, trimmedValue: Number(Math.floor(result?.totalDistance)) };
                case "totalEnginehours":
                  return { ...item, value: this._list?.data?.length ? result?.totalEnginehours : 0, trimmedValue: Number(Math.floor(result?.totalEnginehours)) };
                case "totalAlerts":
                  return { ...item, value: this.alertsCount?.reduce((sum, item) => sum + item.alertsCount, 0), trimmedValue: this.alertsCount?.reduce((sum, item) => sum + item.alertsCount, 0) };
                default:
                  return item; // Leave other items unchanged
              }
            });
          }
        },
        error: () => {
          this.vehicleWidgets = [];
          this.service.toasterService({ type: 'error', msg: Messages.ERROR });
        }
      })
  }

  /**
   * Handles filter selection from top widgets
   * @param value 
   */
  public handleFilterSelection(value: AppliedFilter) {
    this.appliedFilter = value;
    this.widgetFilter.emit(value);
  }


  /**
   * Applies filter selection from Filter Panel
   * @param filtersSelected 
   */
  public applyFilterSelection(filtersSelected: { [key: string]: { [key: string]: boolean } | boolean}) {
    this._appliedFilterCategory = null;
    const result: AppliedFilter = {};
    const widgetFilter: { filterFields: AppliedFilter, operationalStatusFilter: string[], alertsFilter: string[], isActiveAlerts : any, isActiveDTCCases : any } =
      { filterFields: null, operationalStatusFilter: [], alertsFilter: [], isActiveAlerts : filtersSelected?.['isActiveAlerts'] , isActiveDTCCases : filtersSelected?.['isActiveDTCCases']}

    //Populate result array with filters which are true (selected)
    for (const [key, value] of Object.entries(filtersSelected)) {
      const trueKeys = Object.entries(value)
        .filter(([_, isTrue]) => isTrue)
        .map(([field]) => field);

      if (trueKeys.length > 0) {
        if (key === "isActiveAlerts") {
          widgetFilter.isActiveAlerts = true;
        } else if (key === "isActiveDTCCases") {
          widgetFilter.isActiveDTCCases = true;
        } else {
          result[key] = trueKeys;
        }
      }
    }

    widgetFilter.filterFields = result;

    this.isWidgetShow = true;
    this.appliedFilter = result;
    this.entitiyFilters = widgetFilter;
    if (this.appliedFilter && !Object.keys(this.appliedFilter)?.length && !widgetFilter?.operationalStatusFilter?.length && !widgetFilter?.alertsFilter?.length && !this._searchKey && !widgetFilter?.isActiveAlerts && !widgetFilter?.isActiveDTCCases) {
      this.handleBack();
    }
    // this.filterCount = Object.values(this.appliedFilter)?.flat()?.length;
    this.widgetFilter.emit(widgetFilter);
    this._calculateAggregate();
  }

  /** Sets entity onboard form button
  */
  private _setEntityOnboardFormButton() {
    if (this.service?.rbacManagement('entities_EntityAdd')) {
      // Set button label
      let buttonLabel: string = Messages.ENTITY_ONBOARD_TITLE
        ?.replace('[STATUS]', Messages.TEXT_ADD);
      // Set button label based on entityType
      switch (this.list?.entityType) {
        case EntityValue.ASSET:
          buttonLabel = buttonLabel
            ?.replace('[ENTITY_NAME]', Messages.TEXT_ENTITY_ASSET)
          break;

        case EntityValue.VEHICLE:
          buttonLabel = buttonLabel
            ?.replace('[ENTITY_NAME]', Messages.TEXT_ENTITY_VEHICLE)
          break;

        case EntityValue.PEOPLE:
          buttonLabel = buttonLabel
            ?.replace('[ENTITY_NAME]', Messages.TEXT_ENTITY_PEOPLE)
          break;
      }
      // Set button
      this.entityOnboardButton = {
        type: ButtonType.BUTTON,
        option: ButtonOption.ICON,
        icon: 'icon-entity-enroll.svg',
        iconColor: ButtonIconColor.ACTUAL,
        size: ButtonSize.CIRCLE,
        label: buttonLabel,
        color: ButtonColor.PRIMARY,
        action: ActionMode?.ADD,
        tooltip: this.siteId ? null : Messages?.ENTITY_ONBOARD_BUTTON_DISABLE_TOOLTIP,
        disabled: this.siteId ? false : true
      };
    }
  }

  public onCardClick(cardId: string) {
    this.selectedCardId = cardId; // Set the clicked card ID
  }

  public clearCardSelection(event: Event, cardId: string) {
    if (this.selectedCardId === cardId) {
      event.stopPropagation(); // Prevent the card's click event from firing
      this.selectedCardId = null; // Reset the selected card to remove blur
    }
  }

  get hasEntityFilters(): boolean {
    const hasAppliedFilters = this.appliedFilter && Object.keys(this.appliedFilter).length > 0;
    const hasOperationalStatusFilter = this.entitiyFilters?.operationalStatusFilter?.length > 0;
    const hasAlertsFilter = this.entitiyFilters?.alertsFilter?.length > 0;
    const hasSavedFilter = this.service.getFilters('entity') && Object.keys(this.service.getFilters('entity')).length > 0;
    const hasActiveAlerts = this.entitiyFilters.isActiveAlerts || this.service.getAlertDtcFilters('isActiveAlerts');
    const hasActiveDTCCases = this.entitiyFilters.isActiveDTCCases || this.service.getAlertDtcFilters('isActiveDTCCases');

    return hasAppliedFilters || hasOperationalStatusFilter || hasAlertsFilter || hasSavedFilter || hasActiveAlerts || hasActiveDTCCases;
  }


  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      const startDate = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      const endDate = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      this._dataSer.broadcast('entitiesListingdateApplied', {
        startDate: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ')
      });
      this.service.setVehicleDateRange({startDate,endDate});
      this.setLabel = data?.label;
    } else {
      const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
      let { startDate, endDate } = this._tenantGenericConfig?.defaultTimeRange
        ? this.service.calculateDateRange(this._tenantGenericConfig.defaultTimeRange)
        : { startDate: defaultStartDate, endDate: new Date() };
      if(this.service.getVehicleDateRange()?.startDate && this.service.getVehicleDateRange()?.endDate) {
        this.setLabel = this.service?.getRangeSelected();
        startDate = new Date(this.service.getVehicleDateRange()?.startDate);
        endDate = ( this.setLabel=== 'Yesterday' || this.setLabel === 'Custom' ) ? new Date(this.service.getVehicleDateRange()?.endDate) : new Date();
      } else if(this.service.getDateState('global') && !this.service.getVehicleDateRange()?.startDate && !this.service.getVehicleDateRange()?.endDate) {
        this.setLabel = this.service?.getRangeSelected();
        startDate = this.service.getDateState('global')?.date?.startDate;
        endDate = ( this.setLabel=== 'Yesterday' || this.setLabel === 'Custom' ) ? this.service.getDateState('global')?.date?.endDate : new Date();
      }
      this.datepickerForm.setValue({
        thisdate: { startDate, endDate }
      });
      this._dataSer.broadcast('entitiesListingdateApplied', {
        startDate: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ')
      });
      this.service.setVehicleDateRange({startDate,endDate});
    }
  }

  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }
}
